// extracted by mini-css-extract-plugin
module.exports = {"container":"ThankYou_container__ea1ch","title":"ThankYou_title__3b4mD","button":"ThankYou_button__2ZmA7","linkStyle":"ThankYou_linkStyle__2Cmmv"};